module.exports = __webpack_public_path__ + "img/pickles.69682681.svg";